import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('message.find', {
    where: {
      eager: {
        $where: {
          $or: {
            sender: network?.id ? {
              $where: {
                networkId: network.id
              }
            } : undefined,
            recipient: network?.id ? {
              $where: {
                networkId: network.id
              }
            } : undefined
          },
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
